import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'Label',
  props: {
  isRequired: Boolean,
  inputLabel: String,
  id: String,
  value: [Array, String, Boolean, Object],
  modelValue: {},
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props

// eslint-disable-next-line
const isValue = computed(() => {
  const { modelValue, value } = props
  let result = false
  if (modelValue) {
    result = check(modelValue)
  } else if (value) {
    result = check(value)
  }
  return result
})

const check = val => {
  if (Array.isArray(val)) {
    if (val.length) {
      return true
    }
  } else if (val) {
    return true
  }
  return false
}


const __returned__ = { props, isValue, check, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})